import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      window.__lenis = null;
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#141311", border: "1px solid #2A2825", color: "#F5F2EB", fontFamily: '"IBM Plex Mono", monospace', fontSize: "12px" },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
